<template>
  <div class="infor fl">
    <div class="infor-t clearfix">
      <div class="fl infor-t-l">
        <img v-if="ischage" src="../assets/xiugai.png" />
        <!-- {{member.name}} -->
        {{ ischage ? "修改基本信息" : "账户已完善资料概览" }}
      </div>
      <div class="fr infor-t-r" @click="changeinfo()" v-show="!ischage">
        <img src="../assets/19.png" alt="" />
        <span>编辑资料</span>
      </div>
    </div>
    <div v-show="!ischage">
      <Lineconbgtir
        :labelcontainer="labelcontaineragain"
        style="margin-top: 20px"
      />
      <div style="display: flex; margin-top: 16px">
        <div>
          <div style="display: flex">
            <div>
				<div class="tablebox">
				  <div class="thbox-337">
					<div class="tdbox">账号名称</div>
					<div class="tdbox">{{ member.name }}</div>
				  </div>
				</div>
				<div class="tablebox">
				  <div class="thbox-337">
					<div class="tdbox">企业名称</div>
					<div class="tdbox">{{ member.enterprise_name }}</div>
				  </div>
				</div>
				
				<div class="tablebox">
				  <div class="thbox-337">
					<div class="tdbox">企业地址</div>
					<div class="tdbox">{{ member.address }}</div>
				  </div>
				</div>
            </div>
            <div class="tablebox">
              <div class="thbox-289">
                <div class="tdbox">主项资质证书</div>
                <div class="tdbox">
                  <img
                      class="certifications"
                      v-if="member.certifications"
                      :src="member.certifications"
                      alt=""
                    />
                  <div v-if="!member.certifications" class="business">
                    <img
                      class="Businesscertificate"
                      src="@/assets/6952@2x.png"
                      alt=""
                    />
                    <p
                      style="color: #9fa5ae; font-size: 16px"
                    >
                      未上传主项资质证书
                    </p>
                  </div>
                </div>
              </div>
              <div class="thbox-289">
                <div class="tdbox">营业执照</div>
                <div class="tdbox">
                  <img
                      class="certifications"
                      v-if="member.business_license"
                      :src="member.business_license"
                      alt=""
                    />
                  <div class="business" v-if="!member.business_license">
                    <img
                      
                      class="Businesscertificate"
                      src="@/assets/6952@2x.png"
                      alt=""
                    />
                    <p
                      style="color: #9fa5ae; font-size: 16px"
                    >
                      未上传营业执照
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tablebox">
            <div class="thbox-337">
              <div class="tdbox">统一社会信用代码</div>
              <div class="tdbox">{{ member.unified_social_credit_code }}</div>
            </div>
            <div class="thbox-260">
              <div class="tdbox">法定代表人</div>
              <div class="tdbox">{{ member.legal_representative }}</div>
            </div>
            <div class="thbox-260">
              <div class="tdbox">证件号</div>
              <div class="tdbox">{{ member.legal_representative_id }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tablebox">
        <div class="thbox-142">
          <div class="tdbox">企业性质</div>
          <div class="tdbox">{{ member.enterprise_nature }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">经济类型</div>
          <div class="tdbox">{{ member.economic_type }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">是否上市</div>
          <div class="tdbox">{{ member.is_list == 1 ? "是" : "否" }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">成立时间</div>
          <div class="tdbox">
            {{
              member.established_time != null
                ? member.established_time.slice(0, 10)
                : ""
            }}
          </div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">注册资本</div>
          <div class="tdbox">{{ member.registered_capital }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">联系电话</div>
          <div class="tdbox">{{ member.contact_number }}</div>
        </div>
      </div>
      <!-- <table>
        <tr>
          <th width="337px">账号名称</th>
          <th width="233px">法定代表人</th>
        </tr>
        <tr class="cell-color">
          <td>{{ member.name }}</td>
          <td>{{ member.legal_representative }}</td>
        </tr>
        <tr>
          <th>企业名称</th>
          <th>证件号</th>
        </tr>
        <tr class="cell-color">
          <td>{{ member.name }}</td>
          <td>{{ member.legal_representative_id }}</td>
        </tr>
        <tr>
          <th colspan="2">统一社会信用代码</th>
        </tr>
        <tr class="cell-color">
          <td colspan="2">{{ member.unified_social_credit_code }}</td>
        </tr>
      </table> -->
      <!-- 基本介绍 -->
      <Lineconbgtir :labelcontainer="Corporateinfo" style="margin-top: 20px" />
      <div class="tablebox" style="margin-top: 16px">
        <div class="thbox-142">
          <div class="tdbox">法定代表人手机号</div>
          <div class="tdbox">{{ member.other_phone }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">本组织现任职务</div>
          <div class="tdbox">{{ member.job }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">本组织从业人员</div>
          <div class="tdbox">{{ member.is_employees == 1 ? "是" : "否" }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">本组织秘书长</div>
          <div class="tdbox">
            {{ member.is_secretary_general == 1 ? "是" : "否" }}
          </div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">本组织法定代表人</div>
          <div class="tdbox">
            {{ member.is_representative == 1 ? "是" : "否" }}
          </div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">政治面貌</div>
          <div class="tdbox">{{ member.political_outlook }}</div>
        </div>
      </div>
      <div class="tablebox">
        <div class="thbox-142">
          <div class="tdbox">本组织党内职务</div>
          <div class="tdbox">{{ member.party_posts }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">文化程度</div>
          <div class="tdbox">{{ member.education_degree }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">是否社工师</div>
          <div class="tdbox">
            {{ member.is_social_worker == 1 ? "是" : "否" }}
          </div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">职业资格水平</div>
          <div class="tdbox">{{ member.professional_qualification_level }}</div>
        </div>
        <div class="thbox-284">
          <div class="tdbox">党组织关系所在单位</div>
          <div class="tdbox">{{ member.company }}</div>
        </div>
      </div>
      <Lineconbgtir
        :labelcontainer="{ lable: '联系人信息', desc: 'contact information' }"
        style="margin-top: 20px"
      />
      <div class="tablebox" style="margin-top: 16px">
        <div class="thbox-142">
          <div class="tdbox">姓名</div>
          <div class="tdbox">{{ member.contact_user_name }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">工作部门</div>
          <div class="tdbox">{{ member.contact_work_department }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">职务</div>
          <div class="tdbox">{{ member.contact_post }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">固定电话</div>
          <div class="tdbox">{{ member.contact_fixed_telephone }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">移动电话</div>
          <div class="tdbox">{{ member.contact_mobile_phone }}</div>
        </div>
      </div>
      <Lineconbgtir
        :labelcontainer="{ lable: '票据信息', desc: 'Bill information' }"
        style="margin-top: 20px"
      />
      <div class="tablebox" style="margin-top: 16px">
        <div class="thbox-284">
          <div class="tdbox">交款人单位名称</div>
          <div class="tdbox">{{ member.bill_unit_name }}</div>
        </div>
        <div class="thbox-284">
          <div class="tdbox">统一社会信用代码</div>
          <div class="tdbox">{{ member.bill_unified_social_credit_code }}</div>
        </div>
        <div class="thbox-284">
          <div class="tdbox">手机号码</div>
          <div class="tdbox">{{ member.bill_phone }}</div>
        </div>
      </div>
      <Lineconbgtir
        :labelcontainer="{ lable: '基本介绍', desc: 'basic introduction' }"
        style="margin-top: 20px"
      />
      <p style="text-align: start; margin-top: 16px; line-height: 30px">
        {{ member.introduce }}
      </p>
      <div>
        <Lineconbgtir
          :labelcontainer="{ lable: '荣誉项目', desc: 'honorary award' }"
          style="margin-top: 20px"
        />
        <div class="swiper-container scroll" id="swiper2">
          <div class="swiper-wrapper">
            <a
              v-for="(item, index) in prizeList"
              :key="index"
              class="swiper-slide swiper-slide-avatar"
              href="./personal.html"
              target="_blank"
            >
              <img class="" :src="item.img_url" alt="" />
            </a>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <!-- <Lineconbgtir
        :labelcontainer="{
          lable: '近年业绩',
          desc: 'Performance in recent years',
        }"
        style="margin-top: 20px"
      />
      <div class="yearlist">
        <div class="list" v-for="item in 4" :key="item">
          <img class="leftimg" src="@/assets/yearimg.png" alt="" />
          <div class="leftyear">2021</div>
          <div class="output">
            <div class="databox">
              <p class="title"><span class="yellow"></span> 完成总产值</p>
              <p class="count"><span class="yellow">158</span> 亿元</p>
            </div>
            <div class="databox">
              <p class="title"><span class="red"></span> 完成总产值</p>
              <p class="count"><span class="red">158</span> 亿元</p>
            </div>
            <div class="databox">
              <p class="title"><span class="blue"></span> 完成总产值</p>
              <p class="count"><span class="blue">158</span> 亿元</p>
            </div>
          </div>
          <div class="Numberpersonnel">
            <div class="databox">
              <p class="title"><span class="green"></span> 完成总产值</p>
              <p class="count"><span>158</span> 亿元</p>
            </div>
            <div class="databox">
              <p class="title"><span class="graygreen"></span> 完成总产值</p>
              <p class="count"><span>158</span> 亿元</p>
            </div>
          </div>
        </div>
      </div> -->
      
      
      
      
      <!-- <div>
        <div class="block-title">
          <span>基本介绍</span>
          <span>basic introduction</span>
        </div>
        <div class="infor-c">
          {{ member.introduce }}
        </div>
      </div> -->
      <!-- 营业执照 -->
      <!-- <div>
        <div class="block-title">
          <span>营业执照</span>
          <span>business license</span>
        </div>
        <div class="infor-img">
          <img :src="member.business_license" alt="" srcset="" />
        </div>
      </div> -->
      <!-- swiper -->
    </div>
    <div v-show="ischage">
      <CompanInfo :member="member" @isCompanInfo="isCompanInfo" />
    </div>
    <el-dialog
      title="温馨提示"
      :visible.sync="certPrintNoticeVisible"
      width="520px"
      :close-on-click-modal="false"
      :show-close="false">
      <div style="font-size:15px;line-height:1.8;color:#333;text-align:left;padding:0 10px;">
        {{ currentCertPrintNoticeText }}
      </div>
      <span slot="footer">
        <el-button type="primary" @click="confirmCertPrintNotice">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      :visible.sync="rejectNoticeVisible"
      width="520px"
      :close-on-click-modal="false"
      :show-close="false">
      <div style="font-size:15px;line-height:1.8;color:#333;text-align:left;padding:0 10px;">
        {{ currentRejectNoticeText }}
      </div>
      <span slot="footer">
        <el-button type="primary" @click="confirmRejectNotice">{{ currentRejectNoticeActionText }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Lineconbgtir from "./Modal/Line";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import CompanInfo from "./Modal/CompanInfo";
import { GetMember, PrizeList, AwardInfoList } from "../utils/api.js";
export default {
  name: "ForgetHit",
  components: {
    CompanInfo,
    Lineconbgtir,
  },
  props: {},
  data() {
    return {
      labelcontaineragain: {
        lable: "企业信息",
        desc: "Corporate Information",
      },
      Corporateinfo: {
        lable: "法人信息",
        desc: "Legal representative information",
      },
      prizeList: [],
      list: [20],
      ischage: false,
      certPrintNoticeVisible: false,
      certPrintNoticeItems: [],
      certPrintNoticeIndex: 0,
      rejectNoticeVisible: false,
      rejectNoticeItems: [],
      rejectNoticeIndex: 0,
      title: "贵州华盈建筑集团",
      member: {
        name: "",
        contact_number: "",
        unified_social_credit_code: "",
        enterprise_nature: "",
        economic_type: "",
        is_list: "",
        established_time: "",
        registered_capital: "",
        legal_representative: "",
        business_license: "",
      },
    };
  },
  computed: {
    currentCertPrintNoticeText() {
      const item = this.certPrintNoticeItems[this.certPrintNoticeIndex];
      if (!item) return "";
      return `您申报的"${item.name || '贵州省工程建设工法'}"已有证书可以打印，请及时下载打印。`;
    },
    currentRejectNoticeText() {
      const item = this.rejectNoticeItems[this.rejectNoticeIndex];
      if (!item) return "";
      const awardName = this.getRejectNoticeAwardName(item);
      if (this.isRejectNoticeExpired(item)) {
        return `您申报的“${awardName}”材料已被退回，修改时限已到期。申报审核已终止。`;
      }
      if (item.expert_reject_deadline) {
        const deadline = String(item.expert_reject_deadline).slice(0, 10);
        return `您申报的“${awardName}”材料已被专家退回，请根据退回意见要求，于${deadline}前完成修改并重新提交，逾期未提交的审核终止！`;
      }
      return item.pending_notice || "";
    },
    currentRejectNoticeActionText() {
      const item = this.rejectNoticeItems[this.rejectNoticeIndex];
      return this.isRejectNoticeExpired(item) ? "立即查看" : "立即修改";
    },
  },
  created() {},
  async mounted() {
    var swiper = Swiper("#swiper2", {
      observer: true,
      observeParents: true,
      slidesPerView: 9,
      spaceBetween: 0,
      loop: true,
      prevButton: ".swiper-button-prev",
      nextButton: ".swiper-button-next",
      autoplay: 1000, //可选选项，自动滑动
      freeMode: true,
    });
    let member = await GetMember();
    let prizeList = await PrizeList();
    console.log(789, member);

    this.prizeList = prizeList;
    this.member = member;
    if (this.$route.query) {
      this.ischage = false;
    }
    try {
      const res = await AwardInfoList({ award_id: 21, page_size: 50 });
      const certItems = (res.data || []).filter(
        (r) => r.certificate_id && Number(r.publicity_status) === 8
      );
      this.checkCertPrintNotice(certItems);
      const rejected = (res.data || []).filter((r) => {
        const status = Number(r.status);
        return status === 7 || status === 9;
      });
      this.checkRejectNotice(rejected);
    } catch (e) {}
  },
  methods: {
    getRejectNoticeAwardName(item) {
      return item?.content?.info?.name || item?.name || item?.award?.title || "贵州省工程建设工法";
    },
    getRejectNoticeVersion(item) {
      if (!item) return "";
      return `${item.id}_${item.expert_rejected_at || item.admin_rejected_at || item.updated_at || ""}`;
    },
    isRejectNoticeExpired(item) {
      if (!item) return false;
      if (Number(item.status) === 9) return true;
      if (typeof item.can_resubmit === "boolean") return !item.can_resubmit;
      if (!item.expert_reject_deadline) return false;
      const deadline = String(item.expert_reject_deadline).slice(0, 10);
      if (!deadline) return false;
      const today = new Date();
      const currentDate = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
      return currentDate > deadline;
    },
    checkCertPrintNotice(items) {
      const noticeKey = this.getCertPrintNoticeKey();
      if (localStorage.getItem(noticeKey) === 'dismissed') {
        this.certPrintNoticeVisible = false;
        return;
      }
      const first = (Array.isArray(items) ? items : []).find((item) => item);
      this.certPrintNoticeItems = first ? [first] : [];
      this.certPrintNoticeIndex = 0;
      this.certPrintNoticeVisible = this.certPrintNoticeItems.length > 0;
    },
    confirmCertPrintNotice() {
      const noticeKey = this.getCertPrintNoticeKey();
      localStorage.setItem(noticeKey, 'dismissed');
      this.certPrintNoticeVisible = false;
      this.certPrintNoticeIndex = 0;
    },
    getCertPrintNoticeKey() {
      const token = localStorage.getItem('TOKEN') || '';
      return `gf_cert_print_noticed_${token}`;
    },
    checkRejectNotice(items) {
      let noticedIds = [];
      try {
        const stored = sessionStorage.getItem("gf_reject_noticed_ids");
        const parsed = stored ? JSON.parse(stored) : [];
        noticedIds = Array.isArray(parsed) ? parsed.map(String) : [];
      } catch (e) {
        noticedIds = [];
      }
      const filtered = (Array.isArray(items) ? items : []).filter(
        (item) => item && noticedIds.indexOf(this.getRejectNoticeVersion(item)) === -1
      );
      this.rejectNoticeItems = filtered;
      if (this.rejectNoticeItems.length > 0) {
        this.rejectNoticeIndex = 0;
        this.rejectNoticeVisible = true;
      }
    },
    confirmRejectNotice() {
      const current = this.rejectNoticeItems[this.rejectNoticeIndex];
      if (!current) {
        this.rejectNoticeVisible = false;
        return;
      }
      let noticedIds = [];
      try {
        const stored = sessionStorage.getItem("gf_reject_noticed_ids");
        const parsed = stored ? JSON.parse(stored) : [];
        noticedIds = Array.isArray(parsed) ? parsed.map(String) : [];
      } catch (e) {
        noticedIds = [];
      }
      const noticeVersion = this.getRejectNoticeVersion(current);
      if (noticedIds.indexOf(noticeVersion) === -1) {
        noticedIds.push(noticeVersion);
        sessionStorage.setItem("gf_reject_noticed_ids", JSON.stringify(noticedIds));
      }
      this.rejectNoticeVisible = false;
      this.rejectNoticeIndex = 0;
      if (this.isRejectNoticeExpired(current)) {
        this.$router.push({
          path: "/member/Declar_record",
          query: {
            name: "申报记录",
            baid: current.award_id,
            btitle: current.award?.title || current.award_title || "贵州省工程建设工法",
          },
        });
        return;
      }
      this.$router.push({
        path: "/form",
        query: {
          title: current.award?.title || current.award_title || "贵州省工程建设工法",
          id: current.award_id,
          r: current.id,
          award_batch_id: current.award_batch_id,
        },
      });
    },
    isCompanInfo(v) {
      this.ischage = v;
    },
    changeinfo() {
      this.ischage = true;
      this.title = "修改基本资料";
    },
  },
};
</script>
<style lang="less" scoped>
.infor {
  &-t {
    // padding: 14px;
    padding-top: 14px;
    border-bottom: 1px solid #d4dbdd;

    &-l {
      font-size: 28px;
      color: #181e23;
      display: inline-block;
      padding-bottom: 14px;
      font-weight: bold;
      border-bottom: 2px solid #194abe;
    }

    &-r {
      width: 104px;
      height: 31px;
      background: #194abe;
      border: 1px solid #d4dbdd;
      opacity: 1;
      overflow: hidden;
      display: table-cell;
      line-height: 31px;
      cursor: pointer;

      img {
        vertical-align: middle;
      }

      span {
        color: #ffffff;
        font-size: 14px;
      }
    }
  }

  &-c {
    text-align: justify;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #565656;
    padding: 10px 0px;
  }

  &-img {
    text-align: center;
    padding: 24px 0px 40px 0px;
  }
}

// table {
//   width: 858px;
//   text-align: left;
//   // border: 1px solid #D4DBDD;
//   border-collapse: collapse;
//   padding: 0px;
//   margin-top: 24px;
//   margin-bottom: 40px;

//   th {
//     background: #f5f9fb;
//     height: 32px;
//     padding: 0px;
//     color: #194abe;
//     font-size: 16px;
//     padding-left: 17px;
//     border: 1px solid #d4dedd;
// 	box-sizing: border-box;
//   }

//   td {
//     height: 50px;
//     background: #fff;
//     color: #333333;
//     font-weight: bold;
//     font-size: 16px;
//     padding-left: 17px;
//     border: 1px solid #d4dedd;
//   }
// }
.tablebox {
  display: flex;
  .thbox-337,
  .thbox-260,
  .thbox-570,
  .thbox-288,
  .thbox-289,
  .thbox-142,
  .thbox-284 {
    .tdbox {
      box-sizing: border-box;
      margin: -1px -1px 0 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      overflow: hidden;
      &:nth-child(1) {
        height: 32px;
        background: #f5f9fb;
        height: 32px;
        padding: 0px;
        color: #194abe;
        padding-left: 17px;
        border: 1px solid #d4dedd;
      }
      &:nth-child(2) {
        height: 50px;
        background: #fff;
        color: #333333;
        font-weight: bold;
        font-size: 16px;
        padding-left: 17px;
        border: 1px solid #d4dedd;
      }
      .certifications{
        height: 112px;
        margin: 0 auto;
      }
      .business {
        cursor: pointer;
        margin: 0 auto;
        width: 150px;
        height: 112px;
        background: #f1f1f1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        .Businesscertificate {
          width: 97px;
          height: 72px;
        }
      }
    }
  }
  .thbox-337 {
    width: 337px;
  }
  .thbox-260 {
    width: 260px;
  }
  .thbox-570 {
    width: 570px;
  }
  .thbox-142 {
    width: 143px;
  }
  .thbox-284 {
    width: 284px;
  }
  .thbox-288 {
    width: 260px;
    .tdbox:nth-child(2) {
      height: 130px;
      padding: 0;
    }
  }
  .thbox-289 {
    width: 260px;
    .tdbox:nth-child(2) {
      height: 210px;
      padding: 0;
    }
  }
}
.yearlist {
  display: flex;
  flex-direction: column;
  align-items: center;
  .list {
    margin-top: 16px;
    position: relative;
    width: 858px;
    height: 110px;
    display: flex;
    border: 1px dashed #c8cdd5;
    .output,
    .Numberpersonnel {
      width: 402px;
      height: 110px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .title {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
        span {
          display: inline-block;
          margin-right: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
        .yellow {
          background: #f58e19;
          color: #f58e19;
        }
        .red {
          background: #e16068;
          color: #e16068;
        }
        .blue {
          background: #4c6dbb;
          color: #4c6dbb;
        }
      }
      .count {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 24px;
        color: #7c828a;
        span {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 40px;
        }
        .yellow {
          color: #f58e19;
        }
        .red {
          color: #e16068;
        }
        .blue {
          color: #4c6dbb;
        }
      }
    }
    .Numberpersonnel {
      width: 306px;
      background: #f5f9fb;
      .count span {
        color: #414141;
      }
      .title {
        .green {
          background: #25a0b9;
        }
        .graygreen {
          background: #adc263;
        }
      }
    }
    .leftimg {
      position: absolute;
      left: 0;
      top: 0;
      width: 150px;
      height: 110px;
    }
    .leftyear {
      width: 150px;
      height: 110px;
      line-height: 110px;
      font-size: 43px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      position: relative;
      z-index: 1;
    }
  }
}
.block-title {
  width: 842px;
  background: #f5f9fb;
  padding-left: 14px;
  border-left: 3px solid #1852c7;
  height: 40px;
  font-size: 20px;
  font-weight: bold;
  color: #1852c7;
  text-align: left;
  display: table-cell;
  vertical-align: middle;

  span {
    margin-right: 20px;
  }

  span:nth-child(2) {
    font-size: 14px;
    color: #9fa5ae;
  }
}

.scroll {
  position: relative;
  height: 226px;
  // background: url(../image/juxin.png)no-repeat;
  text-align: left;
}

.swiper-wrapper {
  display: flex;
  justify-content: center;
}

.swiper-wrapper-avatar {
  position: relative;
  width: 107px;
  height: 100%;
}

.swiper-slide-avatar {
  height: 226px;
  height: 143px;
  display: inline-block;
  width: 260px !important;
  margin-left: 14px;
}

.swiper-slide-avatar img {
  width: 260px !important;
  height: 143px;
  margin-top: 22px;
}

.swiper-slide-avatar p {
  text-align: center;
  margin-top: 13px;
  font-size: 13px;
}

.swiper-slide-avatar span {
  display: block;
  text-align: center;
  margin-top: 6px;
  color: #8c8076;
  font-size: 12px;
}

.margin-left-30 {
  margin-left: 30px;
}

.infor-img img {
  width: 454px;
  height: 341px;
}

/*Swiper原样式 */
.swiper-button-next {
  background-image: url("../assets/22.png");
}

.swiper-button-prev {
  background-image: url("../assets/21.png");
}

.swiper-button-prev {
  position: absolute;
  top: 50%;
  width: 31px;
  height: 62px;
  margin-top: -31px;
  z-index: 10;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  left: 0px;
}

.swiper-button-next {
  position: absolute;
  top: 50%;
  width: 31px;
  height: 62px;
  margin-top: -31px;
  z-index: 10;
  right: 0px;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
